// directives/droppable.js
const DRAG_MIME = 'text/plain';

function bindDroppable(el, binding) {
  unbindDroppable(el);

  const handler = binding.value;
  if (typeof handler !== 'function') {
    return;
  }

  el._dragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
    el.classList.add('ugo-droppable');
  };

  el._dragLeave = (event) => {
    event.preventDefault();
    if (!el.contains(event.relatedTarget)) {
      el.classList.remove('ugo-droppable');
    }
  };

  el._drop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    el.classList.remove('ugo-droppable');
    const draggedData = event.dataTransfer && event.dataTransfer.getData(DRAG_MIME);
    if (draggedData === '' || draggedData == null) {
      return;
    }
    const currentHandler = el._droppableHandler;
    if (typeof currentHandler === 'function') {
      currentHandler(draggedData, el.dataset);
    }
  };

  el._droppableHandler = handler;
  el.addEventListener('dragover', el._dragOver);
  el.addEventListener('dragleave', el._dragLeave);
  el.addEventListener('drop', el._drop);
}

function unbindDroppable(el) {
  if (el._dragOver) {
    el.removeEventListener('dragover', el._dragOver);
    el.removeEventListener('dragleave', el._dragLeave);
    el.removeEventListener('drop', el._drop);
  }
  el.classList.remove('ugo-droppable');
  delete el._dragOver;
  delete el._dragLeave;
  delete el._drop;
  delete el._droppableHandler;
}

export default {
  bind(el, binding) {
    bindDroppable(el, binding);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      bindDroppable(el, binding);
    } else if (typeof binding.value === 'function') {
      el._droppableHandler = binding.value;
    }
  },
  unbind(el) {
    unbindDroppable(el);
  },
};
